import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IAuthRepository } from '../../repositories/interfaces/iAuthRepository';
import { IAuthApisFormSigatureResponse } from '../../../entity/interface/iAuthApis';
import { setCSRFToken } from '@intigral/utils/lib/browser-storage/localStorage';

export interface IFormSignatureUseCase {
    execute(): Promise<IAuthApisFormSigatureResponse['data']>;
}

export class FormSignatureUseCase implements IFormSignatureUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get authRepo(): IAuthRepository {
        return container.resolve<IAuthRepository>(DI.REPOSITORIES.IAuthRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }
    async execute(): Promise<IAuthApisFormSigatureResponse['data']> {
        const response = await this.authRepo.getFormSignature();
        const data = response.data;
        setCSRFToken(data);
        return data;
    }
}